type DiscountItemAmountArgs<T> = {
  itemsList?: T[] | null
  itemIndex: number
  remainingAmount: number
}

type DiscountItemAmountReturn<T> = {
  itemsList?: T[] | null
  remainingAmount: number
}

export function discountItemAmount<
  T extends {
    amount: number
  },
>({
  itemsList,
  itemIndex,
  remainingAmount,
}: DiscountItemAmountArgs<T>): DiscountItemAmountReturn<T> {
  if (!itemsList || itemIndex < 0 || itemIndex >= itemsList.length) {
    return {
      itemsList,
      remainingAmount,
    }
  }

  const updatedItemsList = [...itemsList]
  const item = updatedItemsList[itemIndex]

  if (remainingAmount === item.amount) {
    updatedItemsList.splice(itemIndex, 1)
    return {
      itemsList: updatedItemsList,
      remainingAmount: 0,
    }
  }

  if (remainingAmount < item.amount) {
    updatedItemsList[itemIndex] = {
      ...item,
      amount: item.amount - remainingAmount,
    }
    return {
      itemsList: updatedItemsList,
      remainingAmount: 0,
    }
  }

  updatedItemsList.splice(itemIndex, 1)

  return {
    itemsList: updatedItemsList,
    remainingAmount: remainingAmount - item.amount,
  }
}
